<div class="container-fluid mt-3">
  <div class="d-flex justify-content-between align-items-center mb-2">
    <h4 class="mb-0">My Tasks</h4>
    <div class="btn-group btn-group-sm" *ngIf="!loading && allTasks.length > 0">
      <button type="button" class="btn" [class.btn-primary]="filter === 'Active'" [class.btn-outline-primary]="filter !== 'Active'"
              (click)="setFilter('Active')">Active</button>
      <button type="button" class="btn" [class.btn-primary]="filter === 'Upcoming'" [class.btn-outline-primary]="filter !== 'Upcoming'"
              (click)="setFilter('Upcoming')">Upcoming</button>
      <button type="button" class="btn" [class.btn-primary]="filter === 'Completed'" [class.btn-outline-primary]="filter !== 'Completed'"
              (click)="setFilter('Completed')">Completed</button>
      <button type="button" class="btn" [class.btn-primary]="filter === 'All'" [class.btn-outline-primary]="filter !== 'All'"
              (click)="setFilter('All')">All</button>
    </div>
  </div>
  <p *ngIf="!loading && allTasks.length > 0" class="text-muted mb-3">
    Showing {{ tasks.length }} of {{ allTasks.length }} {{ allTasks.length === 1 ? 'Task' : 'Tasks' }}
  </p>

  <div *ngIf="loading" class="text-center py-5">
    <i class="fa fa-spinner fa-spin fa-2x"></i>
    <p class="mt-2 text-muted">Loading tasks...</p>
  </div>

  <div *ngIf="!loading && tasks.length === 0" class="text-center py-5">
    <i class="fa fa-inbox fa-3x text-muted"></i>
    <p class="mt-2 text-muted" *ngIf="allTasks.length === 0">No tasks assigned to you.</p>
    <p class="mt-2 text-muted" *ngIf="allTasks.length > 0">No {{ filter === 'All' ? '' : (filter | lowercase) + ' ' }}tasks.</p>
  </div>

  <table *ngIf="!loading && tasks.length > 0" class="table table-hover">
    <thead class="thead-light">
      <tr>
        <th>Candidate</th>
        <th>Type</th>
        <th>Year</th>
        <th>Stage</th>
        <th>Task Status</th>
        <th *ngIf="showCompleted">Case Status</th>
        <th *ngIf="hasOpensOn">Opens On</th>
        <th>Due Date</th>
        <th *ngIf="showCompleted">Completed On</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let task of tasks" [class.table-active]="isActionable(task)">
        <td>
          <a class="text-primary cursor-pointer" (click)="viewPacket(task)">
            {{ task.candidateName }}
          </a>
        </td>
        <td>{{ getWorkflowDisplayName(task.workflowType) }}</td>
        <td>{{ formatYear(task.periodOfReviewId) }}</td>
        <td>{{ getStageName(task.stage) }}</td>
        <td>
          <span class="badge" [ngClass]="getDisplayTaskStatusClass(task)">
            {{ getDisplayTaskStatus(task) }}
          </span>
        </td>
        <td *ngIf="showCompleted">
          <span class="badge" [ngClass]="getCaseStatusClass(task.caseStatus)">
            {{ task.caseStatus }}
          </span>
        </td>
        <td *ngIf="hasOpensOn">{{ task.gateStatus === 'Upcoming' && task.gateOpenDate ? (extractDateFromUtcString(task.gateOpenDate) | date:'mediumDate') : '—' }}</td>
        <td>{{ task.dueDate | date:'mediumDate' }}</td>
        <td *ngIf="showCompleted">{{ task.completedAt ? (task.completedAt | date:'mediumDate') : '—' }}</td>
        <td class="text-right">
          <button
            *ngIf="isActionable(task)"
            class="btn btn-sm btn-outline-primary"
            (click)="openTask(task)">
            Open
          </button>
          <button
            *ngIf="!isActionable(task) && task.status !== 'Cancelled'"
            class="btn btn-sm btn-outline-secondary"
            (click)="openTask(task)">
            View
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>
